<template>
  <q-bar style="min-width: 250px;" class="bg-white">
    <div class="text-primary" style="white-space: nowrap">
      Aquifer Footprint Analysis
    </div>
    <q-space></q-space>
  </q-bar>
  <q-separator></q-separator>
  <supporting-layers
    data="aquifers"
    defaultLayer="1831d27ec7f-layer-23"
  ></supporting-layers>
</template>

<script>
import SupportingLayers from './SupportingLayers.vue';
export default {
  name: 'aquifers',
  components: { SupportingLayers },
  //  mounted() {
  //   this.$store.commit('updateCurrentWebMap', 1);
  // },
  activated() {
    this.$store.commit('updateCurrentWebMap', 'aquifers');
  },
  deactivated() {
    this.$store.commit('updateSaveWebmapExtent', 'aquifers');
  },
  data() {
    return {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#print-header {
  position: absolute;
  top: 0px;
  height: 30px;
}
#print-footer {
  position: absolute;
  bottom: 0px;
  height: 30px;
}
#print-map {
  position: absolute;
  top: 30px;
  height: 500px;
}
</style>
